import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=05d1ade0&scoped=true&"
import script from "./ImgPreview.vue?vue&type=script&lang=js&"
export * from "./ImgPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=05d1ade0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1ade0",
  null
  
)

export default component.exports